export default "__VITE_ASSET__BgMxyc$6__"